import { createAction, props } from '@ngrx/store';
import { Breadcrumbs } from '../reducers/breadcrumbs.reducers';

export const restoreBreadcrumbs = createAction('[BREADCRUMBS] Restore breadcrumbs');

export const setBreadcrumbs = createAction(
    '[BREADCRUMBS] Set breadcrumbs',
    props<{ breadcrumbs: Breadcrumbs[] }>()
);